"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Box = require("./Box.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _excluded = ["variant", "isInteractive", "className", "onClick", "onKeyDown", "href", "children", "disabled", "as", "borderRadius", "minBlockSize", "padding", "paddingBlockStart", "paddingBlockEnd", "paddingInlineStart", "paddingInlineEnd", "hoverBackgroundColor", "activeBackgroundColor", "hasFocus", "hoverAnimationDuration"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * A box is a container used to visually group related content. It’s the flexible foundation used to build Cards and Lists. Use box to create a custom component that's stylistically similar to Cards or Lists, but with a distinct layout. This should be rare. Whenever possible, use cards and lists instead.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-box--docs) |
 * [Encore site](https://encore.spotify.net/web/components/box) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Box)
 */
var Box = exports.Box = /*#__PURE__*/_react["default"].forwardRef(function Box(_ref, ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'naked' : _ref$variant,
    isInteractive = _ref.isInteractive,
    className = _ref.className,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    href = _ref.href,
    children = _ref.children,
    disabled = _ref.disabled,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    borderRadius = _ref.borderRadius,
    minBlockSize = _ref.minBlockSize,
    padding = _ref.padding,
    paddingBlockStart = _ref.paddingBlockStart,
    paddingBlockEnd = _ref.paddingBlockEnd,
    paddingInlineStart = _ref.paddingInlineStart,
    paddingInlineEnd = _ref.paddingInlineEnd,
    hoverBackgroundColor = _ref.hoverBackgroundColor,
    activeBackgroundColor = _ref.activeBackgroundColor,
    hasFocus = _ref.hasFocus,
    hoverAnimationDuration = _ref.hoverAnimationDuration,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var isInteractiveSetOrImplied = isInteractive !== null && isInteractive !== void 0 ? isInteractive : !!onClick || !!href;
  var colorSet = undefined;
  if (variant === 'contrasting') {
    var _props$colorSet;
    colorSet = (_props$colorSet = props.colorSet) !== null && _props$colorSet !== void 0 ? _props$colorSet : 'invertedLight';
  }
  var boxRef = (0, _react.useRef)(null);
  if (ref) {
    boxRef = ref;
  }

  // Treat {Spacebar} and {Enter} presses as clicks if onClick is passed.
  var handleKeyDown = (0, _react.useCallback)(function (e) {
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    if (onClick) {
      if (e.key === ' ' || e.key === 'Spacebar' || e.key === 'Enter') {
        var _boxRef$current;
        e.preventDefault();
        (_boxRef$current = boxRef.current) === null || _boxRef$current === void 0 || _boxRef$current.click();
      }
    }
  }, [onKeyDown, onClick]);
  return /*#__PURE__*/_react["default"].createElement(_Box.BoxComponent, Object.assign({
    as: href ? 'a' : as,
    $variant: variant,
    className: (0, _index.addColorSet)(colorSet, className),
    ref: boxRef,
    tabIndex: isInteractiveSetOrImplied ? 0 : undefined,
    $isInteractive: isInteractiveSetOrImplied,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    href: disabled ? undefined : href,
    disabled: disabled,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.Box,
    $borderRadius: borderRadius,
    $minBlockSize: minBlockSize,
    $padding: padding,
    $paddingBlockStart: paddingBlockStart,
    $paddingBlockEnd: paddingBlockEnd,
    $paddingInlineStart: paddingInlineStart,
    $paddingInlineEnd: paddingInlineEnd,
    $hoverBackgroundColor: hoverBackgroundColor,
    $activeBackgroundColor: activeBackgroundColor,
    $hasFocus: hasFocus,
    $hoverAnimationDuration: hoverAnimationDuration
  }, props), children);
});